import Big from 'big.js'
import { defaultConfig } from './CurrencyInput'

export default function formatCurrency(
  value,
  localeConfig = defaultConfig,
  currencyName = 'USD'
) {
  const numberConfig = localeConfig.formats.number[currencyName]
  const formatter = new global.Intl.NumberFormat(
    localeConfig.locale,
    numberConfig
  )

  return formatter.format(Big(value))
}
